export const CHART_GRID = "hsl(var(--border))";
export const CHART_TICK = { fontSize: 11, fill: "hsl(var(--muted-foreground))" };
export const CHART_TOOLTIP = {
  borderRadius: 4,
  border: "1px solid hsl(var(--border))",
  background: "hsl(var(--popover))",
  color: "hsl(var(--popover-foreground))",
  fontSize: 12,
};
export const CHART_CURSOR = { fill: "hsl(var(--muted))" };
